import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardHeader  from '@material-ui/core/CardHeader';

import CardActions  from '@material-ui/core/CardActions';

import IconButton from '@material-ui/core/IconButton';
import red from '@material-ui/core/colors/red';
import DialogPracticeGuest from './DialogPracticeGuest';

import EditIcon from '@material-ui/icons//Edit';
import Hidden from '@material-ui/core/Hidden';




import AllInboxIcon from '@material-ui/icons/AllInbox';

import _ from 'lodash'
const styles = theme => ({
    actions: {
        display: 'flex',
        padding: theme.spacing.unit * 2
    },
    avatar: {
        backgroundColor: red[500],
    },
    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        marginLeft: 'auto',
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    search: {
        backgroundColor: '#fff',
        padding: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 2,
        borderRight: 'solid 1px #ededed',
        borderLeft: 'solid 1px #ededed',
        borderTop: 'solid 1px #ededed'
    }
})
function a(q, f) {
    try {
        if (q.toLowerCase().includes(f)) {
            return true;
        } else {
            return false;
        }
    } catch (e) {
        return false;
    }
}

let _this;
class CardPracticeGuest extends React.Component {
    constructor() {
        super();
        this.state = { expanded: false, open: false,openAssign:false,search: '',
        checked: [] };
        _this = this;
    }
    handleExpandClick = () => {
        this.setState({ expanded: !this.state.expanded });
    }

    handleOpen = () => {
        this.setState({
            open: !this.state.open,
        });
    }







    handleClose = value => {
        this.setState({ open: false });
        if(this.props.reload)
        {
          this.props.reload();
        }
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };



    render() {

        const { classes, item } = this.props;

        //const ACCOUNT = store.getState().ACCOUNT;
        var subheader = (<span>{"No of practice: "+item.no}</span>);


        return (
            <div>
                <Card key={item.id} style={{ marginBottom: 20 }}>
                    <CardHeader
                        avatar={<AllInboxIcon/>}
                        action={
                            <div style={{ marginTop: 6 }}>
                                <Hidden xsDown>
                                    <IconButton aria-label="Edit" onClick={this.handleOpen} style={{ backgroundColor: '#eee', color: '#555', marginRight: 12 }}>
                                        <EditIcon />
                                    </IconButton>
                                    </Hidden></div>}
                        title={item.name}
                        subheader={subheader}
                    />
                    <Hidden smUp>
                        <CardActions className={classes.actions} disableActionSpacing>


                            <IconButton aria-label="Edit" onClick={this.handleOpen} style={{ backgroundColor: '#eee', color: '#555', marginRight: 12 }}>
                                <EditIcon />
                            </IconButton>

                        </CardActions>
                    </Hidden>


                </Card>
                {this.state.open ? <DialogPracticeGuest
                    item={item}
                    fullScreen={true}
                    open={this.state.open}
                    onClose={this.handleClose}
                /> : ''}
            </div>
        )
    }
}

CardPracticeGuest.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CardPracticeGuest);
